import * as yup from 'yup'

export class VehicleCheckInAirbagTellTalePhotoDto {
  documentGuid?: string = undefined
  displayFileName?: string = undefined
    vehicleCheckInAirbagTellTalePhotoFile?: File = undefined
  vehicleCheckInAirbagTellTalePhotoType?: string = undefined
}

export const vehicleCheckInAirbagTellTalePhotoValidationSchema = yup.object({
  vehicleCheckInAirbagTellTalePhotoFile: yup.mixed().notRequired()
})
